import { render, staticRenderFns } from "./assistant-launcher.vue?vue&type=template&id=2aa3a072&scoped=true"
import script from "./assistant-launcher.vue?vue&type=script&lang=js"
export * from "./assistant-launcher.vue?vue&type=script&lang=js"
import style0 from "./assistant-launcher.vue?vue&type=style&index=0&id=2aa3a072&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aa3a072",
  null
  
)

export default component.exports